
import React from 'react';

const TableOfContents = () => {
  return (
    <section className="mb-8">
      <h2 className="text-2xl font-semibold mb-4">Table of Contents</h2>
      <div className="space-y-2 text-gray-600">
        <p>A. General</p>
        <p>I. Scope of application</p>
        <p>II. Definitions</p>
        <p>III. Name and address of the data controller</p>
        <p>IV. Contact details of the data protection officer</p>
        <p>V. Legal basis for data processing</p>
        <p>VI. Data deletion and storage period</p>
        <p>VII. Data security</p>
        <p>VIII. Collaboration with processors</p>
        <p>IX. Requirements for the transfer of personal data to third countries</p>
        <p>X. No automated decision-making</p>
        <p>XI. No obligation to provide personal data</p>
        <p>XII. Legal obligation to transmit certain data</p>
        <p>XIII. Your rights</p>
        <p>XIV. Changes to this Privacy Policy</p>
        <p>B. Visiting the Website, App and social media presence</p>
        <p>C. Contact by email</p>
        <p>D. Contractual relationship with us as service provider</p>
        <p>E. Contractual Relationship with us as business partner</p>
      </div>
    </section>
  );
};

export default TableOfContents;
